import { Div, Span, Text } from '@tblabs/truffle';
import { ICamera } from '../../Services/Camera/ICamera';
import { SignalStrengthIndicator } from './SignalStrengthIndicator/SignalStrengthIndicator';
import { Status } from '../../Services/Status/Status';
import { IServer } from '../../Services/IServer';
import { Svg } from '../General/Svg';
import { Icons } from '../Icons';


export class StatusBox extends Div
{
    constructor(_server: IServer, _camera: ICamera, _status: Status) 
    {
        super("uk-background-secondary");

        this.Append(
            new SignalStrengthIndicator(_server, _camera).Class("signal"),
            new Text(_status.TextStatus).Class("status"),
            new Text(_status.TimerText).Class("timer"),
        )
    }
}

export class StatusBoxV2 extends Div
{
    constructor(_server: IServer, _camera: ICamera, _status: Status) 
    {
        super("uk-background-secondary");

        this.Append(
            new SignalStrengthIndicator(_server, _camera).Class("signal"),
            // new Text(_status.TextStatus).Class("status"),
            // new Text(_status.TimerText).Class("timer"),
            new Span("|").Color("#666").MarginLeftRight(8),
            new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-camera-icon lucide-camera"><path d="M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z"/><circle cx="12" cy="13" r="3"/></svg>`).Color("#555").Width(18),
            new Span("1922").Color("#ccc").FontSize(12).MarginLeft(4),
            new Span("|").Color("#666").MarginLeftRight(8),
            new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-unplug-icon lucide-unplug"><path d="m19 5 3-3"/><path d="m2 22 3-3"/><path d="M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z"/><path d="M7.5 13.5 10 11"/><path d="M10.5 16.5 13 14"/><path d="m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z"/></svg>`).Color("#666").Width(18),
            new Span("OK").Color("#ccc").FontSize(12).MarginLeft(4),
            new Span("|").Color("#666").MarginLeftRight(8),
            new Svg(Icons.VolumeX).Color("#666").Width(18),
        )
    }
}
